<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="名称" prop="name">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.name"
          placeholder="请输入名称"
        />
      </Form-item>
      <Form-item label="任课老师" prop="teacherId">
        <c-teacher-select
          class="c-form__input"
          :value="cForm.model.teacherId"
          @change="
            value => {
              $set(cForm.model, 'teacherId', value);
            }
          "
        >
        </c-teacher-select>
      </Form-item>
      <Form-item label="上课地点" prop="address">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.address"
          placeholder="请输入地点"
        />
      </Form-item>
      <Form-item label="开班/结课时间">
        <DatePicker
          :value="cForm.model.startsAt"
          type="date"
          placeholder="请选择开班时间"
          style="width: 155px"
          @on-change="
            value => {
              $set(cForm.model, 'startsAt', value);
            }
          "
        />
        -
        <DatePicker
          :value="cForm.model.endsAt"
          type="date"
          placeholder="请选择结课时间"
          style="width: 155px"
          @on-change="
            value => {
              $set(cForm.model, 'endsAt', value);
            }
          "
        />
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "classes";

@Component({
  mixins: [FormMixin]
})
export default class ListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          name: [
            {
              required: true,
              message: "名称不能为空"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {};
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;
        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: model
          }
        );

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list", data);
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
